<template>
  <component
    @scroll="containerProps.onScroll"
    :is="tagName"
    v-bind="containerProps"
    style="height: 100%"
    v-if="list && showElements"
    class="[&>*]:duration-0 duration-0 overflow-auto"
    :class="{ hideScrollBar }"
    id="bigContainer"
  >
    <slot name="header" />
    <div
      ref="topReachedElement"
      class="top-0 w-full flex justify-center items-center z-12 pointer-events-none"
      :class="{
        'h-[35px]': loadingMoreTop,
        'h-[5px]': !loadingMoreTop,
      }"
      style="transition-duration: 500ms !important"
    >
      <svg
        v-if="loadingMoreTop"
        aria-hidden="true"
        class="mx-auto w-6 h-6 text-gray-200 animate-spin"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="white"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="#755A83"
        />
      </svg>
    </div>
    <div
      v-bind="wrapperProps"
      :style="{
        ...wrapperProps.style,
        height: `calc(${wrapperProps.style?.height})`,
      }"
      class="pb-0 relative"
    >
      <component
        v-for="(item, i) in list"
        :key="i"
        :is="childTagName"
        :style="{
          height: itemContainerHeight + 'px',
          width: itemContainerWidth,
        }"
        :class="[
          itemsClasses,
          itemsClassesFunction({ item: item.data, index: item.index }) || '',
        ]"
        @click="
          () => {
            onChildClick({ item: item.data, index: item.index });
          }
        "
      >
        <slot
          :data="{
            isShimmer: item.data.isShimmer,
            item: item.data.isShimmer ? {} : item.data,
            index: item.index,
          }"
        ></slot>
      </component>
    </div>
    <div
      ref="bottomReachedElement"
      class="pt-0 bottom-0 w-full flex items-center justify-center pointer-events-none"
      :class="{ '!hidden': directUseItems }"
      :style="{ height: loadingMoreEnd ? '35px' : '5px' }"
      style="transition-duration: 500ms !important"
    >
      <svg
        v-if="loadingMoreEnd"
        aria-hidden="true"
        class="mx-auto w-6 h-6 text-gray-200 animate-spin"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="white"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="#755A83"
        />
      </svg>
    </div>
    <ScrollComponent
      :customTagSelector="scrollContainerSelector"
      :hideScrollBar="hideScrollBar"
      fillScrollBarMissingWithPadding
    />
  </component>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useVirtualList, useElementVisibility } from "@vueuse/core";
import ScrollComponent from "./ScrollComponent.vue";

export default defineComponent({
  name: "ListComponentVirtualScroll",
  components: {
    ScrollComponent,
    /* UseVirtualList */
    /* vElementVisibility */
  },
  props: {
    directUseItems: {
      type: Boolean,
      default: false,
    },
    hideScrollBar: {
      type: Boolean,
      default: false,
    },
    allItems: {
      type: Array,
      default: () => {
        return [
          { isShimmer: true },
          { isShimmer: true },
          { isShimmer: true },
          { isShimmer: true },
          { isShimmer: true },
        ];
      },
    },
    getItems: {
      type: Function,
      default: (offset, limit) => {
        return [];
      },
    },
    itemContainerHeight: {
      type: [Number, String],
      default: 40,
    },
    itemContainerWidth: {
      type: [Number, String],
      default: 40,
    },
    itemsClasses: {
      type: [String, Array, Object],
      default: "",
    },
    itemsClassesFunction: {
      type: Function,
      default: ({ item, i }) => {
        return "";
      },
    },
    onChildClick: {
      type: Function,
      default: ({ item, i }) => {
      },
    },
    tagName: {
      type: String,
      default: "div",
    },
    childTagName: {
      type: String,
      default: "div",
    },
    itemsVisibilityCheckingMargeInPx: {
      type: Number,
      default: 0,
    },
    firstLoadingItems: {
      type: Number,
      default: 4,
    },
    itemsPerPage: {
      type: Number,
      default: 20,
    },
    additionnalLoadingItems: {
      type: Number,
      default: 15,
    },
    bottomLoadingHeight: {
      type: String,
      default: "50px",
    },
    scrollContainerSelector: {
      type: String,
      default: "#bigContainer",
    },
  },
  setup() {
    const { list, containerProps, wrapperProps } = useVirtualList(
      ref([
        { isShimmer: true },
        { isShimmer: true },
        { isShimmer: true },
        { isShimmer: true },
        { isShimmer: true },
      ]),
      {
        itemHeight: 50,
        overscan: 10,
      }
    );

    const bottomReachedElement = ref(null);
    const topReachedElement = ref(null);
    let bottomReachedIsVisible = ref(false);
    let topReachedIsVisible = ref(false);
    bottomReachedIsVisible = useElementVisibility(bottomReachedElement);
    topReachedIsVisible = useElementVisibility(topReachedElement);
    return {
      bottomReachedElement,
      bottomReachedIsVisible,
      topReachedElement,
      topReachedIsVisible,
      list,
      containerProps,
      wrapperProps,
      // list: ref([]),
      // containerProps: ref({}),
      // wrapperProps: ref({}),
    };
  },
  data() {
    return {
      items: [],
      loadingMore: true,
      loadingMoreEnd: true,
      loadingMoreTop: false,
      firstLoadingDone: false,
      showElements: false,
      // list:ref([]),
      // containerProps: ref({}),
      // wrapperProps: ref({}),
    };
  },
  async mounted() {
    this.makeFirstCompute();
    this.showElements = true;
    // if (!this.directUseItems) {
    await this.computeListData(null, this.firstLoadingItems, true, [], false);
    // }
    setTimeout(() => {
      this.loadingMore = false;
      this.loadingMoreEnd = false;
      this.firstLoadingDone = true;
    }, 1000);
  },
  unmounted() {},
  methods: {
    makeFirstCompute() {
      const shimmerList = [
        { isShimmer: true },
        { isShimmer: true },
        { isShimmer: true },
        { isShimmer: true },
        { isShimmer: true },
      ];
      const { list, containerProps, wrapperProps } = useVirtualList(
        ref(this.directUseItems ? this.allItems : shimmerList),
        {
          itemHeight: this.itemContainerHeight,
          overscan: 10,
        }
      );
      this.list = list;
      this.containerProps = containerProps;
      this.wrapperProps = wrapperProps;
      this.$forceUpdate();
    },
    async onBottomElementVisibility() {
      console.log("BottomElementVisible");
      if (this.loadingMore) return;
      if (this.directUseItems) return;
      this.loadingMore = true;
      this.loadingMoreEnd = true;
      let nbItemsToLoad = this.additionnalLoadingItems;
      const start = this.items[this.items.length - 1];
      await this.computeListData(start, nbItemsToLoad, true);
      this.loadingMore = false;
      this.loadingMoreEnd = false;
    },
    async onTopElementVisibility() {
      console.log("TopElementVisible");
      if (this.loadingMore) return;
      if (this.directUseItems) return;
      this.loadingMore = true;
      this.loadingMoreTop = true;
      let nbItemsToLoad = this.additionnalLoadingItems;
      let start = this.items[0];
      await this.computeListData(start, nbItemsToLoad, false);
      this.loadingMore = false;
      this.loadingMoreTop = false;
    },
    async refreshData(
      cleanDataWhileLoading = false,
      firstItem = this.items[0],
      canRefreshAgainIfAlreadyRefreshing = true
    ) {
      console.log("refresh called");
      if (this.loadingMore) {
        console.log("will cancel refresh cause already loading");
        if (canRefreshAgainIfAlreadyRefreshing) {
          this.refreshAfterCurrentRefresh = true;
        }
        return;
      }
      console.log("will make refresh");
      if (cleanDataWhileLoading) this.emptyList();
      this.loadingMore = true;
      this.loadingMoreEnd = true;
      await this.computeListData(firstItem, this.itemsPerPage, true, [], false);
      console.log("refresh done");
      this.loadingMore = false;
      this.loadingMoreEnd = false;
      if (this.refreshAfterCurrentRefresh) {
        this.refreshAfterCurrentRefresh = false;
        this.refreshData(cleanDataWhileLoading, firstItem, false);
      }
    },
    emptyList() {
      const { list, containerProps, wrapperProps } = useVirtualList(ref([]), {
        itemHeight: this.itemContainerHeight,
        overscan: 10,
      });
      this.list = list;
      this.containerProps = containerProps;
      this.wrapperProps = wrapperProps;
      console.log("data empty");
    },
    async computeListData(
      from,
      limit,
      addNewItemsToEnd,
      sourceItems = this.items,
      makeScroll = true
    ) {
      if (this.directUseItems) {
        return this.directRefreshData();
      }
      console.log("will load data", from, limit);
      const newItems = await this.getItems(
        from,
        addNewItemsToEnd ? limit : limit * -1
      );
      let items = [...sourceItems, ...newItems];
      if (!addNewItemsToEnd) items = [...newItems, ...sourceItems];

      let itemsStart = items.length - this.itemsPerPage;
      if (!addNewItemsToEnd) itemsStart = 0;
      if (itemsStart < 0) itemsStart = 0;
      this.items =
        items?.slice(itemsStart, itemsStart + this.itemsPerPage) || [];

      const { list, containerProps, wrapperProps } = useVirtualList(
        ref(this.items),
        {
          itemHeight: this.itemContainerHeight,
          overscan: 10,
        }
      );

      this.list = list;
      this.containerProps = containerProps;
      // containerProps.onScroll=()=>{
      //   console.log("wil scrooool")
      //   containerProps.onScroll()
      // }
      this.wrapperProps = wrapperProps;

      this.$forceUpdate();

      if (makeScroll && newItems.length) {
        const newElementsDistance = newItems.length * this.itemContainerHeight;

        document.querySelector(this.scrollContainerSelector).scrollBy({
          behavior: "instant",
          top: addNewItemsToEnd
            ? -1 * newElementsDistance
            : newElementsDistance,
        });
      }

      await new Promise((r) => setTimeout(r, 1000));
    },
    directRefreshData() {
      const { list, containerProps, wrapperProps } = useVirtualList(
        ref(this.allItems),
        {
          itemHeight: this.itemContainerHeight,
          overscan: 10,
        }
      );
      this.list = list;
      this.containerProps = containerProps;
      this.wrapperProps = wrapperProps;
      this.$forceUpdate();
    },
  },
  computed: {},
  watch: {
    topReachedIsVisible(newValue) {
      if (newValue !== true) return;
      this.onTopElementVisibility();
    },
    bottomReachedIsVisible(newValue) {
      if (newValue !== true) return;
      this.onBottomElementVisibility();
    },
    allItems() {
      if (!this.directUseItems) return;
      this.directRefreshData();
    },
  },
});
</script>
